import { ibkApi } from '@ibk/shared-config';
import { blobToBase64, parseOrderPaymentPdfResponse } from './contractOrderPaymentApi';
export const buildGenerateOrderReportPdfMutation = ({ contractId, orderId }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/pdf`,
    method: 'POST',
    responseHandler: parseOrderPaymentPdfResponse,
});
export const contractOrderReportApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        generateEmissorOrderReportPdf: build.mutation({
            query: buildGenerateOrderReportPdfMutation,
            transformResponse: (response) => blobToBase64(response),
        }),
    }),
    overrideExisting: false,
});
export const { useGenerateEmissorOrderReportPdfMutation } = contractOrderReportApi;
